<template>
<v-layout v-if="widget" :is="widget" :entities="entities" v-on="$listeners" ></v-layout>
</template>

<script>
import * as Filters from './FilterWidgets'

export default {
	name: "JmTableFilter",

	props: {
		type: String,
		entities: Array
	},

	data () {
		return {
			widgets: {
				journey: Filters.JmFilterJourney,
				location: Filters.JmFilterLocation,
				asset: Filters.JmFilterAsset,
				person: Filters.JmFilterPerson
			}
		}
	},

	computed: {
		widget () {
			return this.type
				? this.widgets[this.type]
				: undefined;
		}
	},

	components: {
		...Filters
	}
}

</script>



// WEBPACK FOOTER //
// src/components/widgets/TableFilter.vue